export default __webpack_public_path__ + "static/media/MapPoint-dark.4a4620fc.svg";